import { Component, Input } from '@angular/core';

/**
 * Indicador de carregamento de listagem (`MSG-10`), num lugar só.
 *
 * É uma **barra no topo da tabela**, não um spinner que ocupa o lugar dela: a tela continua
 * legível e o cabeçalho e os filtros continuam clicáveis. Spinner de tela cheia esconde
 * justamente o filtro que a pessoa acabou de mudar, e transforma cada digitação num piscar
 * da tela inteira.
 */
@Component({
  selector: 'app-barra-carregando',
  standalone: true,
  template: `
    <div class="barra" role="status" [attr.aria-label]="rotulo">
      <span class="indicador"></span>
    </div>
  `,
  styles: [
    `
      .barra {
        position: relative;
        height: 3px;
        width: 100%;
        overflow: hidden;
        background: var(--background-basic-color-3, #e4e9f2);
        border-radius: 3px 3px 0 0;
      }

      .indicador {
        position: absolute;
        inset: 0 auto 0 0;
        width: 35%;
        background: var(--color-primary-default, #3366ff);
        animation: desliza 1.1s ease-in-out infinite;
      }

      @keyframes desliza {
        0% {
          left: -35%;
        }
        100% {
          left: 100%;
        }
      }

      /* Quem pediu menos movimento vê uma barra estática, não uma tela sem aviso nenhum. */
      @media (prefers-reduced-motion: reduce) {
        .indicador {
          animation: none;
          left: 0;
          width: 100%;
          opacity: 0.5;
        }
      }
    `,
  ],
})
export class BarraCarregandoComponent {
  /** Lido por leitor de tela; a barra em si não tem texto. */
  @Input() rotulo = 'Carregando…';
}
